<div *ngIf="RoleId=='1' || RoleId=='2'" class="row colour" style="font-size:16px;">
    <div class="col-lg-12">

        <div class="panel panel-default" style="box-shadow: 0 2px 8px 0 rgba(0,0,0,0.2);transition: 0.3s;">

            <div class="panel-heading">
                <h3 class="panel-title"><i class="fa fa-bar-chart-o"></i> Chart</h3>
            </div>


            <div id="width" class="panel-body" style="display: flex; align-content:center;padding-left:55px!important;
                padding-right:55px!important;margin-bottom:0 !important;">
                <br />
                <br />
                <div class="slideScreen">
                    <div id="chart" class="w3-display-container mySlides" style="overflow:hidden;">
                        <h3 class="colour"
                            style="text-align:left !important;margin-bottom:30px !important;font-size:22px!important;">
                            Accuracy Overview (No. of records Vs. Accuracy)
                            <span
                                style="display:inline !important;border-left:1px solid #EAEAEA;border-right:1px solid #EAEAEA;padding:0 10px;color:#2D973F;float:right!important;">
                                Total Records :
                                <b>{{total_records}}</b>
                                <span
                                    style="display:inline !important;border-left:1px solid #EAEAEA;padding:0 10px;margin-right:0 !important;color:#00A3AE;">
                                    Total Categories :
                                    <b>{{total_categories}}</b>
                                </span>
                            </span>
                        </h3>

                        <div style="border: 2px solid #FCFCFC; background-color:#FCFCFC ">
                            <div class="legend"></div>
                            <div class="chart" style="overflow:auto!important;">
                                <nvd3 [options]="options" [data]="data"></nvd3>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>

    <div class="row colour" style="font-size:16px;">

        <div class="col-lg-4">
            <div class="card" style="height:170px;padding:15px 35px;text-align:center;">
                <h3 style="color:#646464!important;font-size:16px!important;">Want to update with new data?</h3>
                <br>
                <a routerLink="/Train"><button type="button" class="btn btn-lg btn-primary buttonStyle"><b></b>Start
                        training</button></a>

            </div>
        </div>
        <div class="col-lg-4">
            <div class="card" style="height:170px;padding:15px 35px;text-align:center;">
                <h3 style="color:#646464!important;font-size:16px!important;">
                    Have new Excel file to predict Tax codes?</h3>
                <br>
                <a routerLink="/Predict"><button type="button" class="btn btn-lg btn-primary buttonStyle">Predict
                    </button></a>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card" style="min-height:170px;height:auto;padding:15px 35px;text-align:center;">

                <h3 style="color:#646464!important;font-size:16px!important;">New Tax Code Mapping data </h3>
                <br>
                <a routerLink="/Home/Update"><button id="button" type="button"
                        class="btn btn-lg btn-primary buttonStyle">Update</button></a>

            </div>
        </div>

    </div>

</div>